import React, { useState } from 'react'
import { toAbsoluteUrl } from "../../services";


function Success(props) {

    let { text,onclick } = props


    return (
        <div>
            <div className='bg-[#DEFFF1] p-[15px] border border-[#0C7649] success-msg-wrapper flex items-center justify-center w-[65%] mt-7 ml-auto mr-auto'>
                <span className='thumbsup-img flex-shrink-0 mr-2'>
                    <img src={toAbsoluteUrl(`/media/home/thumbs-up.svg`)} loading='eager'  alt="thumb image" />
                </span>
                <p className='text-[16px] text-[#0C7649]'>{text}</p>
                <span onClick={onclick} className='ml-4'>
                    <img src={toAbsoluteUrl(`/media/home/ant-design_close-circle-outlined.svg`)} />
                </span>
            </div>
        </div>
    )
}

export default Success